<template>
  <div id="app">
    <router-view/>
  </div>
</template>


<script>
import versionJSON from '../src/utils/versionJSON.json'
import moment from "moment/moment";

export default {
  created() {
    console.log('------------------------------')
    console.log(process.env.VUE_APP_OUTPUT_NAME)
    console.log('版本更新时间:'+moment(versionJSON.compileTime).format('YYYY/MM/DD, HH:mm:ss'))
    console.log('------------------------------')
  }
}
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333333;
}
</style>
